/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConfirmEntryRequest } from '../models/ConfirmEntryRequest';
import type { ConfirmInternalEntryRequest } from '../models/ConfirmInternalEntryRequest';
import type { ConfirmReturnRequest } from '../models/ConfirmReturnRequest';
import type { ConfirmReturnResponse } from '../models/ConfirmReturnResponse';
import type { ConfirmWriteOffRequest } from '../models/ConfirmWriteOffRequest';
import type { ConfirmWriteOffResponse } from '../models/ConfirmWriteOffResponse';
import type { Countries } from '../models/Countries';
import type { CreateActiveSubstanceRequest } from '../models/CreateActiveSubstanceRequest';
import type { CreateActiveSubstanceResponse } from '../models/CreateActiveSubstanceResponse';
import type { CreateConsumableRequest } from '../models/CreateConsumableRequest';
import type { CreateConsumablesImportRequest } from '../models/CreateConsumablesImportRequest';
import type { CreateEntryRequest } from '../models/CreateEntryRequest';
import type { CreateFormRequest } from '../models/CreateFormRequest';
import type { CreateFundingSourceRequest } from '../models/CreateFundingSourceRequest';
import type { CreateGroupRequest } from '../models/CreateGroupRequest';
import type { CreateInquiryRequest } from '../models/CreateInquiryRequest';
import type { CreateInternalConsumptionRequest } from '../models/CreateInternalConsumptionRequest';
import type { CreateInternalInquiryRequest } from '../models/CreateInternalInquiryRequest';
import type { CreateInternalIssuanceRequest } from '../models/CreateInternalIssuanceRequest';
import type { CreateInternalReturnRequest } from '../models/CreateInternalReturnRequest';
import type { CreateInternationalNameRequest } from '../models/CreateInternationalNameRequest';
import type { CreateIssuanceRequest } from '../models/CreateIssuanceRequest';
import type { CreateMeasurementUnitRequest } from '../models/CreateMeasurementUnitRequest';
import type { CreateMedicinesImportRequest } from '../models/CreateMedicinesImportRequest';
import type { CreateProducerRequest } from '../models/CreateProducerRequest';
import type { CreateProductRequest } from '../models/CreateProductRequest';
import type { CreateReturnRequest } from '../models/CreateReturnRequest';
import type { CreateSubstanceUnitRequest } from '../models/CreateSubstanceUnitRequest';
import type { CreateTvaRateRequest } from '../models/CreateTvaRateRequest';
import type { CreateWriteOffRequest } from '../models/CreateWriteOffRequest';
import type { ExternalEntryDocumentResponse } from '../models/ExternalEntryDocumentResponse';
import type { GetActiveSubstanceResponse } from '../models/GetActiveSubstanceResponse';
import type { GetAvailableConsumablesResponse } from '../models/GetAvailableConsumablesResponse';
import type { GetAvailableMedicineListResponse } from '../models/GetAvailableMedicineListResponse';
import type { GetConsumableListResponse } from '../models/GetConsumableListResponse';
import type { GetConsumableResponse } from '../models/GetConsumableResponse';
import type { GetFormListResponse } from '../models/GetFormListResponse';
import type { GetFormResponse } from '../models/GetFormResponse';
import type { GetGroupListResponse } from '../models/GetGroupListResponse';
import type { GetGroupResponse } from '../models/GetGroupResponse';
import type { GetInternationalNameListResponse } from '../models/GetInternationalNameListResponse';
import type { GetInternationalNameResponse2 } from '../models/GetInternationalNameResponse2';
import type { GetMeasurementUnitListResponse } from '../models/GetMeasurementUnitListResponse';
import type { GetMeasurementUnitResponse } from '../models/GetMeasurementUnitResponse';
import type { GetMedicineListResponse } from '../models/GetMedicineListResponse';
import type { GetMedicineResponse } from '../models/GetMedicineResponse';
import type { GetPrescriptionListResponse } from '../models/GetPrescriptionListResponse';
import type { GetProducerListResponse } from '../models/GetProducerListResponse';
import type { GetProducerResponse } from '../models/GetProducerResponse';
import type { GetSubstanceUnitListResponse } from '../models/GetSubstanceUnitListResponse';
import type { GetSubstanceUnitResponse } from '../models/GetSubstanceUnitResponse';
import type { GetTvaRateListResponse } from '../models/GetTvaRateListResponse';
import type { GetTvaRateResponse } from '../models/GetTvaRateResponse';
import type { InquiryDocumentResponse } from '../models/InquiryDocumentResponse';
import type { InternalConsumptionDocumentResponse } from '../models/InternalConsumptionDocumentResponse';
import type { InternalDocumentListResponse } from '../models/InternalDocumentListResponse';
import type { InternalEntryDocumentResponse } from '../models/InternalEntryDocumentResponse';
import type { InternalInquiryDocumentResponse } from '../models/InternalInquiryDocumentResponse';
import type { InternalInventoryDocumentListResponse } from '../models/InternalInventoryDocumentListResponse';
import type { InternalInventoryDocumentState } from '../models/InternalInventoryDocumentState';
import type { InternalInventoryListResponse } from '../models/InternalInventoryListResponse';
import type { InternalIssuanceDocumentResponse } from '../models/InternalIssuanceDocumentResponse';
import type { InternalReturnDocumentResponse } from '../models/InternalReturnDocumentResponse';
import type { InternationalNameUsability } from '../models/InternationalNameUsability';
import type { InventoryDocumentState } from '../models/InventoryDocumentState';
import type { InventoryItemSettingsResponse } from '../models/InventoryItemSettingsResponse';
import type { InventoryListResponse } from '../models/InventoryListResponse';
import type { InventoryStatus } from '../models/InventoryStatus';
import type { InvoicedDocumentListResponse } from '../models/InvoicedDocumentListResponse';
import type { IssuanceAllowance } from '../models/IssuanceAllowance';
import type { IssuanceDocumentResponse } from '../models/IssuanceDocumentResponse';
import type { ProductGroupCategory } from '../models/ProductGroupCategory';
import type { RejectEntryRequest } from '../models/RejectEntryRequest';
import type { RejectInquiryRequest } from '../models/RejectInquiryRequest';
import type { RejectInternalEntryRequest } from '../models/RejectInternalEntryRequest';
import type { RejectInternalInquiryRequest } from '../models/RejectInternalInquiryRequest';
import type { RejectInternalIssuanceRequest } from '../models/RejectInternalIssuanceRequest';
import type { RejectIssuanceRequest } from '../models/RejectIssuanceRequest';
import type { RestoreWriteOffRequest } from '../models/RestoreWriteOffRequest';
import type { ReturnDocumentResponse } from '../models/ReturnDocumentResponse';
import type { SendWriteOffRequest } from '../models/SendWriteOffRequest';
import type { UpdateActiveSubstanceRequest } from '../models/UpdateActiveSubstanceRequest';
import type { UpdateConsumableRequest } from '../models/UpdateConsumableRequest';
import type { UpdateFormRequest } from '../models/UpdateFormRequest';
import type { UpdateFundingSourceRequest } from '../models/UpdateFundingSourceRequest';
import type { UpdateGroupRequest } from '../models/UpdateGroupRequest';
import type { UpdateInquiryRequest } from '../models/UpdateInquiryRequest';
import type { UpdateInternalInquiryRequest } from '../models/UpdateInternalInquiryRequest';
import type { UpdateInventoryItemSettingsCommand } from '../models/UpdateInventoryItemSettingsCommand';
import type { UpdateMeasurementUnitRequest } from '../models/UpdateMeasurementUnitRequest';
import type { UpdateMedicineRequest } from '../models/UpdateMedicineRequest';
import type { UpdateProducerRequest } from '../models/UpdateProducerRequest';
import type { UpdateSubstanceRequest } from '../models/UpdateSubstanceRequest';
import type { UpdateSubstanceUnitRequest } from '../models/UpdateSubstanceUnitRequest';
import type { UpdateTvaRateRequest } from '../models/UpdateTvaRateRequest';
import type { UpdateWriteOffRequest } from '../models/UpdateWriteOffRequest';
import type { UpdateWriteOffResponse } from '../models/UpdateWriteOffResponse';
import type { WriteOffDocumentResponse } from '../models/WriteOffDocumentResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StocksService {
    /**
     * Updates a TVA rate.
     * Updates a TVA rate with provided details.
     * @param id TVA rate identifier.
     * @param requestBody
     * @returns any The TVA rate has been updated successfully.
     * @throws ApiError
     */
    public static updateTvaRateEndpoint(
        id: string,
        requestBody: UpdateTvaRateRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/stocks/products/tva-rates/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The TVA rate has not been found.`,
            },
        });
    }
    /**
     * Gets a TVA rate.
     * Gets a TVA rate with details.
     * @param id TVA rate identifier.
     * @returns GetTvaRateResponse The TVA rate has been found.
     * @throws ApiError
     */
    public static getTvaRateEndpoint(
        id: string,
    ): CancelablePromise<GetTvaRateResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/products/tva-rates/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The TVA rate has not been found.`,
            },
        });
    }
    /**
     * Deletes the TVA rate.
     * Deletes the TVA rate by its id.
     * @param id TVA rate identifier.
     * @returns void
     * @throws ApiError
     */
    public static deleteTvaRateEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/stocks/products/tva-rates/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The TVA rate has not been found.`,
            },
        });
    }
    /**
     * Gets a list of TVA rates.
     * Gets a list of TVA rates.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param searchTerm Search by the TVA rate name.
     * @returns GetTvaRateListResponse List of TVA rates has been retrieved successfully.
     * @throws ApiError
     */
    public static getTvaRateListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        searchTerm?: string | null,
    ): CancelablePromise<GetTvaRateListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/products/tva-rates',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates a TVA rate.
     * Creates a TVA rate with provided details.
     * @param requestBody
     * @returns any The TVA rate has been created successfully.
     * @throws ApiError
     */
    public static createTvaRateEndpoint(
        requestBody: CreateTvaRateRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/products/tva-rates',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The TVA rate has not been found.`,
            },
        });
    }
    /**
     * Updates a producer.
     * Updates a producer with provided details.
     * @param id Producer identifier.
     * @param requestBody
     * @returns any The producer has been updated successfully.
     * @throws ApiError
     */
    public static updateProducerEndpoint(
        id: string,
        requestBody: UpdateProducerRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/stocks/products/producers/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The producer has not been found.`,
            },
        });
    }
    /**
     * Gets a producer.
     * Gets a producer with details.
     * @param id Producer identifier.
     * @returns GetProducerResponse The producer has been found.
     * @throws ApiError
     */
    public static getProducerEndpoint(
        id: string,
    ): CancelablePromise<GetProducerResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/products/producers/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The producer has not been found.`,
            },
        });
    }
    /**
     * Deletes the producer.
     * Deletes the producer by its id.
     * @param id Producer identifier.
     * @returns void
     * @throws ApiError
     */
    public static deleteProducerEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/stocks/products/producers/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The producer has not been found.`,
            },
        });
    }
    /**
     * Gets a list of producers.
     * Gets a list of producers.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param searchTerm Search by the producer name.
     * @returns GetProducerListResponse List of producers has been retrieved successfully.
     * @throws ApiError
     */
    public static getProducerListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        searchTerm?: string | null,
    ): CancelablePromise<GetProducerListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/products/producers',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates a producer.
     * Creates a producer with provided details.
     * @param requestBody
     * @returns any The producer has been created successfully.
     * @throws ApiError
     */
    public static createProducerEndpoint(
        requestBody: CreateProducerRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/products/producers',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The producer has not been found.`,
            },
        });
    }
    /**
     * Updates a product.
     * Updates a product with provided details.
     * @param id
     * @param requestBody
     * @returns any The product has been updated successfully.
     * @throws ApiError
     */
    public static updateMedicineEndpoint(
        id: string,
        requestBody: UpdateMedicineRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/stocks/products/medicines/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The product has not been found.`,
            },
        });
    }
    /**
     * Gets a product.
     * Gets a product with details.
     * @param id Medicine identifier.
     * @returns GetMedicineResponse The product has been found.
     * @throws ApiError
     */
    public static getMedicineEndpoint(
        id: string,
    ): CancelablePromise<GetMedicineResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/products/medicines/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The product has not been found.`,
            },
        });
    }
    /**
     * Deletes the product.
     * Deletes the product by its id.
     * @param id Medicine identifier.
     * @returns void
     * @throws ApiError
     */
    public static deleteProductEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/stocks/products/medicines/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The product has not been found.`,
            },
        });
    }
    /**
     * Gets a list of prescription types.
     * Gets a list of prescription types.
     * @returns GetPrescriptionListResponse List of prescription types has been retrieved successfully.
     * @throws ApiError
     */
    public static getPrescriptionListEndpoint(): CancelablePromise<GetPrescriptionListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/products/medicines/prescriptions',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Starts a product import.
     * Starts a product import.
     * @param id Excel file to import.
     * @param requestBody
     * @returns any The import has been finished successfully.
     * @throws ApiError
     */
    public static createMedicinesImportEndpoint(
        id: string,
        requestBody: CreateMedicinesImportRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/products/medicines/import/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets a list of products.
     * Gets a list of products.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param searchTerm Search by the products.
     * @param country Search by the country.
     * @param formId Search by the product form.
     * @param producerId Search by the producer id.
     * @param groupId
     * @param internationalNameIds Search by the international names.
     * @param ids
     * @returns GetMedicineListResponse List of producers has been retrieved successfully.
     * @throws ApiError
     */
    public static getMedicineListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        searchTerm?: string | null,
        country?: Countries | null,
        formId?: string | null,
        producerId?: string | null,
        groupId?: string | null,
        internationalNameIds?: Array<string> | null,
        ids?: Array<string> | null,
    ): CancelablePromise<GetMedicineListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/products/medicines',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'country': country,
                'formId': formId,
                'producerId': producerId,
                'groupId': groupId,
                'internationalNameIds': internationalNameIds,
                'ids': ids,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates a product.
     * Creates a product with provided details.
     * @param requestBody
     * @returns any The product has been created successfully.
     * @throws ApiError
     */
    public static createProductEndpoint(
        requestBody: CreateProductRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/products/medicines',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets available medicines.
     * This endpoint requires the following permissions: [  ]
     * @param pageNumber
     * @param pageSize
     * @param institutionIds
     * @param searchTerm
     * @returns GetAvailableMedicineListResponse Success
     * @throws ApiError
     */
    public static getAvailableListEndpoint(
        pageNumber: number,
        pageSize: number,
        institutionIds?: Array<string> | null,
        searchTerm?: string | null,
    ): CancelablePromise<GetAvailableMedicineListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/products/available-medicines',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'institutionIds': institutionIds,
                'searchTerm': searchTerm,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Updates an active substance.
     * Updates an active substance with provided details.
     * @param id Substance identifier.
     * @param requestBody
     * @returns any The substance has been updated successfully.
     * @throws ApiError
     */
    public static updateSubstanceEndpoint(
        id: string,
        requestBody: UpdateSubstanceRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/stocks/products/names/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The substance has not been found.`,
            },
        });
    }
    /**
     * Gets a producer.
     * Gets an active substance with details.
     * @param id Active substance identifier.
     * @returns GetInternationalNameResponse2 The producer has been found.
     * @throws ApiError
     */
    public static getInternationalNameEndpoint(
        id: string,
    ): CancelablePromise<GetInternationalNameResponse2> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/products/names/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The producer has not been found.`,
            },
        });
    }
    /**
     * Deletes the substance.
     * Deletes the substance by its id.
     * @param id Active substance identifier.
     * @returns void
     * @throws ApiError
     */
    public static deleteInternationalNameEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/stocks/products/names/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The substance has not been found.`,
            },
        });
    }
    /**
     * Updates a measurement unit.
     * Updates a measurement unit with provided details.
     * @param id Measurement unit identifier.
     * @param requestBody
     * @returns any The measurement unit has been updated successfully.
     * @throws ApiError
     */
    public static updateSubstanceUnitEndpoint(
        id: string,
        requestBody: UpdateSubstanceUnitRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/stocks/products/names/units/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The measurement unit has not been found.`,
            },
        });
    }
    /**
     * Gets a measurement unit.
     * Gets a measurement unit with details.
     * @param id Producer identifier.
     * @returns GetSubstanceUnitResponse The measurement unit has been found.
     * @throws ApiError
     */
    public static getSubstanceUnitEndpoint(
        id: string,
    ): CancelablePromise<GetSubstanceUnitResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/products/names/units/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The measurement unit has not been found.`,
            },
        });
    }
    /**
     * Deletes the measurement unit.
     * Deletes the measurement unit by its id.
     * @param id Measurement unit identifier.
     * @returns void
     * @throws ApiError
     */
    public static deleteSubstanceUnitEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/stocks/products/names/units/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The measurement unit has not been found.`,
            },
        });
    }
    /**
     * Gets a list of measurement units.
     * Gets a list of measurement units.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param searchTerm Search by the measurement unit name.
     * @returns GetSubstanceUnitListResponse List of measurement units has been retrieved successfully.
     * @throws ApiError
     */
    public static getSubstanceUnitListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        searchTerm?: string | null,
    ): CancelablePromise<GetSubstanceUnitListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/products/names/units',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates a measurement unit.
     * Creates a measurement unit with provided details.
     * @param requestBody
     * @returns any The measurement unit has been created successfully.
     * @throws ApiError
     */
    public static createSubstanceUnitEndpoint(
        requestBody: CreateSubstanceUnitRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/products/names/units',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The measurement unit has not been found.`,
            },
        });
    }
    /**
     * Gets a list of active substances.
     * Gets a list of active substances.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param usability
     * @param searchTerm Search by the producer name.
     * @returns GetInternationalNameListResponse List of active substances has been retrieved successfully.
     * @throws ApiError
     */
    public static getInternationalNameListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        usability?: InternationalNameUsability,
        searchTerm?: string | null,
    ): CancelablePromise<GetInternationalNameListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/products/names',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'usability': usability,
                'searchTerm': searchTerm,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates an active substance.
     * Creates an active substance with provided details.
     * @param requestBody
     * @returns any The active substance has been created successfully.
     * @throws ApiError
     */
    public static createInternationalNameEndpoint(
        requestBody: CreateInternationalNameRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/products/names',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The substance has not been found.`,
            },
        });
    }
    /**
     * Updates an active substance.
     * Updates an active substance with provided details.
     * @param id Substance identifier.
     * @param requestBody
     * @returns any The substance has been updated successfully.
     * @throws ApiError
     */
    public static updateActiveSubstanceEndpoint(
        id: string,
        requestBody: UpdateActiveSubstanceRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/stocks/products/names/substances/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The substance has not been found.`,
            },
        });
    }
    /**
     * Gets an active substance.
     * Gets an active substance with details.
     * @param id Active substance identifier.
     * @returns GetActiveSubstanceResponse The producer has been found.
     * @throws ApiError
     */
    public static getActiveSubstanceEndpoint(
        id: string,
    ): CancelablePromise<GetActiveSubstanceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/products/names/substances/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The producer has not been found.`,
            },
        });
    }
    /**
     * Deletes the substance.
     * Deletes the substance by its id.
     * @param id Active substance identifier.
     * @returns void
     * @throws ApiError
     */
    public static deleteActiveSubstanceEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/stocks/products/names/substances/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The substance has not been found.`,
            },
        });
    }
    /**
     * Gets a list of active substances.
     * Gets a list of active substances.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param searchTerm Search by the producer name.
     * @returns any List of active substances has been retrieved successfully.
     * @throws ApiError
     */
    public static getActiveSubstanceListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        searchTerm?: string | null,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/products/names/substances',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates an active substance.
     * Creates an active substance with provided details.
     * @param requestBody
     * @returns CreateActiveSubstanceResponse The active substance has been created successfully.
     * @throws ApiError
     */
    public static createActiveSubstanceEndpoint(
        requestBody: CreateActiveSubstanceRequest,
    ): CancelablePromise<CreateActiveSubstanceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/products/names/substances',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The substance has not been found.`,
            },
        });
    }
    /**
     * Updates an pharmaceutical group.
     * Updates a pharmaceutical group with provided details.
     * @param id Pharmaceutical group identifier.
     * @param requestBody
     * @returns any The group has been updated successfully.
     * @throws ApiError
     */
    public static updateGroupEndpoint(
        id: string,
        requestBody: UpdateGroupRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/stocks/products/groups/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The group has not been found.`,
            },
        });
    }
    /**
     * Gets a pharmaceutical form.
     * Gets a pharmaceutical form with details.
     * @param id Group identifier.
     * @returns GetGroupResponse The pharmaceutical group has been found.
     * @throws ApiError
     */
    public static getGroupEndpoint(
        id: string,
    ): CancelablePromise<GetGroupResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/products/groups/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The pharmaceutical form has not been found.`,
            },
        });
    }
    /**
     * Deletes the pharmaceutical group.
     * Deletes the pharmaceutical group by its id.
     * @param id Pharmaceutical group identifier.
     * @returns void
     * @throws ApiError
     */
    public static deleteGroupEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/stocks/products/groups/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The pharmaceutical group has not been found.`,
            },
        });
    }
    /**
     * Gets a list of pharmaceutical groups.
     * Gets a list of pharmaceutical groups.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param searchTerm Search by the pharmaceutical group name.
     * @param category
     * @returns GetGroupListResponse List of pharmaceutical groups has been retrieved successfully.
     * @throws ApiError
     */
    public static getGroupListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        searchTerm?: string | null,
        category?: ProductGroupCategory | null,
    ): CancelablePromise<GetGroupListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/products/groups',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'category': category,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates a pharmaceutical group.
     * Creates a pharmaceutical form with provided details.
     * @param requestBody
     * @returns any The pharmaceutical form has been created successfully.
     * @throws ApiError
     */
    public static createGroupEndpoint(
        requestBody: CreateGroupRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/products/groups',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The pharmaceutical form has not been found.`,
            },
        });
    }
    /**
     * Updates a funding source.
     * Updates a funding source with the provided details.
     * @param id Funding source identifier.
     * @param requestBody
     * @returns any The funding source has been updated successfully.
     * @throws ApiError
     */
    public static updateFundingSourceEndpoint(
        id: string,
        requestBody: UpdateFundingSourceRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/stocks/products/funding-sources/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `The user is not authorized.`,
                404: `The funding source was not found.`,
            },
        });
    }
    /**
     * Gets a funding source.
     * Gets a funding source with its details.
     * @param id The identifier of the funding source.
     * @returns GetGroupResponse The funding source has been found.
     * @throws ApiError
     */
    public static getFundingSourceEndpoint(
        id: string,
    ): CancelablePromise<GetGroupResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/products/funding-sources/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `The user is not authorized.`,
                404: `The funding source was not found.`,
            },
        });
    }
    /**
     * Deletes the funding source.
     * Deletes the funding source by its ID.
     * @param id The identifier of the funding source.
     * @returns void
     * @throws ApiError
     */
    public static deleteFundingSourceEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/stocks/products/funding-sources/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `The user is not authorized.`,
                404: `The funding source was not found.`,
            },
        });
    }
    /**
     * Gets a list of funding sources.
     * Gets a list of funding sources.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param searchTerm Search by the name of the funding source.
     * @returns GetGroupListResponse List of funding sources has been retrieved successfully.
     * @throws ApiError
     */
    public static getListFundingSourceEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        searchTerm?: string | null,
    ): CancelablePromise<GetGroupListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/products/funding-sources',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `The user is not authorized.`,
            },
        });
    }
    /**
     * Creates a funding source.
     * Creates a funding source with the provided details.
     * @param requestBody
     * @returns any The funding source has been created successfully.
     * @throws ApiError
     */
    public static createFundingSourceEndpoint(
        requestBody: CreateFundingSourceRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/products/funding-sources',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `The user is not authorized.`,
                404: `The funding source was not found.`,
            },
        });
    }
    /**
     * Updates an pharmaceutical form.
     * Updates a pharmaceutical form with provided details.
     * @param id Pharmaceutical form identifier.
     * @param requestBody
     * @returns any The form has been updated successfully.
     * @throws ApiError
     */
    public static updateFormEndpoint(
        id: string,
        requestBody: UpdateFormRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/stocks/products/forms/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The form has not been found.`,
            },
        });
    }
    /**
     * Gets a pharmaceutical form.
     * Gets a pharmaceutical form with details.
     * @param id Producer identifier.
     * @returns GetFormResponse The pharmaceutical form has been found.
     * @throws ApiError
     */
    public static getFormEndpoint(
        id: string,
    ): CancelablePromise<GetFormResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/products/forms/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The pharmaceutical form has not been found.`,
            },
        });
    }
    /**
     * Deletes the pharmaceutical form.
     * Deletes the pharmaceutical form by its id.
     * @param id Pharmaceutical form identifier.
     * @returns void
     * @throws ApiError
     */
    public static deleteFormEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/stocks/products/forms/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The pharmaceutical form has not been found.`,
            },
        });
    }
    /**
     * Gets a list of pharmaceutical forms.
     * Gets a list of pharmaceutical forms.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param internationalNameId International name to filter by.
     * @param searchTerm Search by the pharmaceutical form name.
     * @returns GetFormListResponse List of pharmaceutical forms has been retrieved successfully.
     * @throws ApiError
     */
    public static getFormListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        internationalNameId?: string | null,
        searchTerm?: string | null,
    ): CancelablePromise<GetFormListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/products/forms',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'internationalNameId': internationalNameId,
                'searchTerm': searchTerm,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates a pharmaceutical form.
     * Creates a pharmaceutical form with provided details.
     * @param requestBody
     * @returns any The pharmaceutical form has been created successfully.
     * @throws ApiError
     */
    public static createFormEndpoint(
        requestBody: CreateFormRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/products/forms',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The pharmaceutical form has not been found.`,
            },
        });
    }
    /**
     * Updates a consumable product.
     * Updates a consumable product with provided details.
     * @param id
     * @param requestBody
     * @returns any The product has been updated successfully.
     * @throws ApiError
     */
    public static updateConsumableEndpoint(
        id: string,
        requestBody: UpdateConsumableRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/stocks/products/consumables/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The product has not been found.`,
            },
        });
    }
    /**
     * Gets a consumable product.
     * Gets a consumable product with details.
     * @param id Consumable identifier.
     * @returns GetConsumableResponse The product has been found.
     * @throws ApiError
     */
    public static getConsumableEndpoint(
        id: string,
    ): CancelablePromise<GetConsumableResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/products/consumables/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The product has not been found.`,
            },
        });
    }
    /**
     * Deletes the consumable product.
     * Deletes the consumable product by its id.
     * @param id Consumable identifier.
     * @returns void
     * @throws ApiError
     */
    public static deleteConsumableEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/stocks/products/consumables/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The product has not been found.`,
            },
        });
    }
    /**
     * Updates a measurement unit.
     * Updates a measurement unit with provided details.
     * @param id Measurement unit identifier.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static updateMeasurementUnitEndpoint(
        id: string,
        requestBody: UpdateMeasurementUnitRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/stocks/products/consumables/units/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The measurement unit has not been found.`,
            },
        });
    }
    /**
     * Gets a measurement unit.
     * Gets a measurement unit with details.
     * @param id Producer identifier.
     * @returns GetMeasurementUnitResponse The measurement unit has been found.
     * @throws ApiError
     */
    public static getMeasurementUnitEndpoint(
        id: string,
    ): CancelablePromise<GetMeasurementUnitResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/products/consumables/units/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The measurement unit has not been found.`,
            },
        });
    }
    /**
     * Deletes the measurement unit.
     * Deletes the measurement unit by its id.
     * @param id Measurement unit identifier.
     * @returns void
     * @throws ApiError
     */
    public static deleteMeasurementUnitEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/stocks/products/consumables/units/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The measurement unit has not been found.`,
            },
        });
    }
    /**
     * Gets a list of measurement units.
     * Gets a list of measurement units.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param searchTerm Search by the measurement unit name.
     * @returns GetMeasurementUnitListResponse List of measurement units has been retrieved successfully.
     * @throws ApiError
     */
    public static getMeasurementUnitListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        searchTerm?: string | null,
    ): CancelablePromise<GetMeasurementUnitListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/products/consumables/units',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates a measurement unit.
     * Creates a measurement unit with provided details.
     * @param requestBody
     * @returns any The measurement unit has been created successfully.
     * @throws ApiError
     */
    public static createMeasurementUnitEndpoint(
        requestBody: CreateMeasurementUnitRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/products/consumables/units',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The measurement unit has not been found.`,
            },
        });
    }
    /**
     * Starts a product import.
     * Starts a product import.
     * @param id Excel file to import.
     * @param requestBody
     * @returns any The import has been finished successfully.
     * @throws ApiError
     */
    public static createConsumablesImportEndpoint(
        id: string,
        requestBody: CreateConsumablesImportRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/products/consumables/import/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets a list of consumable products.
     * Gets a list of consumable products.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param searchTerm Search by the products.
     * @param country Search by the country.
     * @param unitId Search by the product measurement unit id.
     * @param producerId Search by the producer id.
     * @param internationalNameId
     * @param groupId
     * @param ids
     * @returns GetConsumableListResponse List of products has been retrieved successfully.
     * @throws ApiError
     */
    public static getConsumableListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        searchTerm?: string | null,
        country?: Countries | null,
        unitId?: string | null,
        producerId?: string | null,
        internationalNameId?: string | null,
        groupId?: string | null,
        ids?: Array<string> | null,
    ): CancelablePromise<GetConsumableListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/products/consumables',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'country': country,
                'unitId': unitId,
                'producerId': producerId,
                'internationalNameId': internationalNameId,
                'groupId': groupId,
                'ids': ids,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates a consumable product.
     * Creates a consumable product with provided details.
     * @param requestBody
     * @returns any The product has been created successfully.
     * @throws ApiError
     */
    public static createConsumableEndpoint(
        requestBody: CreateConsumableRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/products/consumables',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Get available consumables.
     * This endpoint requires the following permissions: [  ]
     * @param pageNumber
     * @param pageSize
     * @param institutionIds
     * @param searchTerm
     * @returns GetAvailableConsumablesResponse Success
     * @throws ApiError
     */
    public static getAvailableConsumablesEndpoint(
        pageNumber: number,
        pageSize: number,
        institutionIds?: Array<string> | null,
        searchTerm?: string | null,
    ): CancelablePromise<GetAvailableConsumablesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/products/available-consumables',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'institutionIds': institutionIds,
                'searchTerm': searchTerm,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Updates a write-off document.
     * This endpoint requires the following permissions: [ Stocks.Stock.Update.WriteOffs ]
     * @param id
     * @param requestBody
     * @returns UpdateWriteOffResponse Success
     * @throws ApiError
     */
    public static updateWriteOffEndpoint(
        id: string,
        requestBody: UpdateWriteOffRequest,
    ): CancelablePromise<UpdateWriteOffResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/stocks/inventory/write-offs/{id}/update',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Sends a write-off document to be approved.
     * This endpoint requires the following permissions: [ Stocks.Stock.Send.WriteOffs ]
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static sendWriteOffEndpoint(
        id: string,
        requestBody: SendWriteOffRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/stocks/inventory/write-offs/{id}/send',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Restore a write-off document
     * This endpoint requires the following permissions: [ Stocks.Stock.Cancel.WriteOffs ]
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static restoreWriteOffEndpoint(
        id: string,
        requestBody: RestoreWriteOffRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/stocks/inventory/write-offs/{id}/restore',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Gets a list of inventory returns.
     * Gets a list of inventory returns.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param states
     * @param documentNumber
     * @param institutionIds Search by the institution ids.
     * @param legalEntityIds
     * @param fromDate Search by the invoice date.
     * @param toDate Search by the invoice date.
     * @param searchTerm
     * @returns InternalDocumentListResponse List of inventory returns has been retrieved successfully.
     * @throws ApiError
     */
    public static getWriteOffListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        states?: Array<InventoryDocumentState> | null,
        documentNumber?: string | null,
        institutionIds?: Array<string> | null,
        legalEntityIds?: Array<string> | null,
        fromDate?: string | null,
        toDate?: string | null,
        searchTerm?: string | null,
    ): CancelablePromise<InternalDocumentListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/inventory/write-offs',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'states': states,
                'documentNumber': documentNumber,
                'institutionIds': institutionIds,
                'legalEntityIds': legalEntityIds,
                'fromDate': fromDate,
                'toDate': toDate,
                'searchTerm': searchTerm,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates an inventory return.
     * Creates an inventory return with provided details.
     * @param requestBody
     * @returns any The write off has been created successfully.
     * @throws ApiError
     */
    public static createWriteOffEndpoint(
        requestBody: CreateWriteOffRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/inventory/write-offs',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets a product.
     * Gets a product with details.
     * @param id Medicine identifier.
     * @returns WriteOffDocumentResponse The product has been found.
     * @throws ApiError
     */
    public static getWriteOffEndpoint(
        id: string,
    ): CancelablePromise<WriteOffDocumentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/inventory/write-offs/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The product has not been found.`,
            },
        });
    }
    /**
     * Accept or reject a write-off request
     * This endpoint requires the following permissions: [ Stocks.Stock.Confirm.WriteOffs ]
     * @param id
     * @param requestBody
     * @returns ConfirmWriteOffResponse Success
     * @throws ApiError
     */
    public static confirmWriteOffEndpoint(
        id: string,
        requestBody: ConfirmWriteOffRequest,
    ): CancelablePromise<ConfirmWriteOffResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/stocks/inventory/write-offs/{id}/confirm',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Updates an inventory item settings.
     * Updates an inventory item settings with provided details.
     * @param id
     * @param requestBody
     * @returns any The inventory item has been updated successfully.
     * @throws ApiError
     */
    public static updateInventoryItemSettingsEndpoint(
        id: string,
        requestBody: UpdateInventoryItemSettingsCommand,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/stocks/inventory/{id}/settings',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The inventory item has not been found.`,
            },
        });
    }
    /**
     * Gets inventory item settings.
     * Gets settings related to an inventory item.
     * @param id Inventory item id.
     * @returns InventoryItemSettingsResponse The settings found.
     * @throws ApiError
     */
    public static getInventoryItemSettingsEndpoint(
        id: string,
    ): CancelablePromise<InventoryItemSettingsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/inventory/{id}/settings',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The settings not found.`,
            },
        });
    }
    /**
     * Gets a list of inventory returns.
     * Gets a list of inventory returns.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param states
     * @param documentNumber
     * @param companyIds Search by the the company ids.
     * @param institutionIds Search by the institution ids.
     * @param legalEntityIds
     * @param fromDate Search by the invoice date.
     * @param toDate Search by the invoice date.
     * @param searchTerm
     * @returns InvoicedDocumentListResponse List of inventory returns has been retrieved successfully.
     * @throws ApiError
     */
    public static getReturnListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        states?: Array<InventoryDocumentState> | null,
        documentNumber?: string | null,
        companyIds?: Array<string> | null,
        institutionIds?: Array<string> | null,
        legalEntityIds?: Array<string> | null,
        fromDate?: string | null,
        toDate?: string | null,
        searchTerm?: string | null,
    ): CancelablePromise<InvoicedDocumentListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/inventory/returns',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'states': states,
                'documentNumber': documentNumber,
                'companyIds': companyIds,
                'institutionIds': institutionIds,
                'legalEntityIds': legalEntityIds,
                'fromDate': fromDate,
                'toDate': toDate,
                'searchTerm': searchTerm,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates an inventory return.
     * Creates an inventory return with provided details.
     * @param requestBody
     * @returns any The return has been created successfully.
     * @throws ApiError
     */
    public static createReturnEndpoint(
        requestBody: CreateReturnRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/inventory/returns',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets a product.
     * Gets a product with details.
     * @param id Medicine identifier.
     * @returns ReturnDocumentResponse The product has been found.
     * @throws ApiError
     */
    public static getReturnEndpoint(
        id: string,
    ): CancelablePromise<ReturnDocumentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/inventory/returns/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The product has not been found.`,
            },
        });
    }
    /**
     * Confirms or rejects a return
     * This endpoint requires the following permissions: [ Stocks.Stock.Confirm.Returns, Stocks.Stock.Accept.Returns ]
     * @param id
     * @param requestBody
     * @returns ConfirmReturnResponse Success
     * @throws ApiError
     */
    public static confirmReturnEndpoint(
        id: string,
        requestBody: ConfirmReturnRequest,
    ): CancelablePromise<ConfirmReturnResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/stocks/inventory/returns/{id}/confirm',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The item has not been found.`,
            },
        });
    }
    /**
     * Rejects an inventory issuance.
     * Rejects an inventory issuance by its id.
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static rejectIssuanceEndpoint(
        id: string,
        requestBody: RejectIssuanceRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/inventory/issuance/{id}/reject',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The entry has not been found.`,
            },
        });
    }
    /**
     * Gets a list of issuances.
     * Gets a list of issuances.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param states
     * @param documentNumber
     * @param companyIds Search by the the company ids.
     * @param institutionIds Search by the institution ids.
     * @param legalEntityIds
     * @param fromDate Search by the invoice date.
     * @param toDate Search by the invoice date.
     * @param searchTerm
     * @returns InvoicedDocumentListResponse List of issuances has been retrieved successfully.
     * @throws ApiError
     */
    public static getIssuanceListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        states?: Array<InventoryDocumentState> | null,
        documentNumber?: string | null,
        companyIds?: Array<string> | null,
        institutionIds?: Array<string> | null,
        legalEntityIds?: Array<string> | null,
        fromDate?: string | null,
        toDate?: string | null,
        searchTerm?: string | null,
    ): CancelablePromise<InvoicedDocumentListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/inventory/issuance',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'states': states,
                'documentNumber': documentNumber,
                'companyIds': companyIds,
                'institutionIds': institutionIds,
                'legalEntityIds': legalEntityIds,
                'fromDate': fromDate,
                'toDate': toDate,
                'searchTerm': searchTerm,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates an inventory issuance.
     * Creates an inventory issuance with provided details.
     * @param requestBody
     * @returns any The issuance has been created successfully.
     * @throws ApiError
     */
    public static createIssuanceEndpoint(
        requestBody: CreateIssuanceRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/inventory/issuance',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets an issuance.
     * Gets an issuance details.
     * @param id Issuance identifier.
     * @returns IssuanceDocumentResponse The issuance has been found.
     * @throws ApiError
     */
    public static getIssuanceEndpoint(
        id: string,
    ): CancelablePromise<IssuanceDocumentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/inventory/issuance/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The product has not been found.`,
            },
        });
    }
    /**
     * Updates an inventory inquiry.
     * Updates an inventory inquiry with provided details.
     * @param id
     * @param requestBody
     * @returns any The entry has been created successfully.
     * @throws ApiError
     */
    public static updateInquiryEndpoint(
        id: string,
        requestBody: UpdateInquiryRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/stocks/inventory/inquiries/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets a product.
     * Gets a product with details.
     * @param id Medicine identifier.
     * @returns InquiryDocumentResponse The product has been found.
     * @throws ApiError
     */
    public static getInquiryEndpoint(
        id: string,
    ): CancelablePromise<InquiryDocumentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/inventory/inquiries/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The product has not been found.`,
            },
        });
    }
    /**
     * Deletes an inventory inquiry to the stock authority.
     * Deletes an inventory inquiry to the stock authority
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteInquiryEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/stocks/inventory/inquiries/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The inquiry has not been found.`,
            },
        });
    }
    /**
     * Sends an inventory inquiry to the stock authority.
     * Sends an inventory inquiry to the stock authority
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static sendInquiryEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/inventory/inquiries/{id}/send',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The inquiry has not been found.`,
            },
        });
    }
    /**
     * Rejects an inventory inquiry.
     * Rejects an inventory inquiry by its id.
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static rejectInquiryEndpoint(
        id: string,
        requestBody: RejectInquiryRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/inventory/inquiries/{id}/reject',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The entry has not been found.`,
            },
        });
    }
    /**
     * Gets a list of inventory inquiry items.
     * Gets a list of inquiry items.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param states Search by the state.
     * @param internationalNameId
     * @param code
     * @param institutionIds Search by the institution ids.
     * @param legalEntityIds
     * @param fromDate Search by the invoice date.
     * @param toDate Search by the invoice date.
     * @param searchTerm
     * @returns InvoicedDocumentListResponse List of inventory items has been retrieved successfully.
     * @throws ApiError
     */
    public static getInquiryListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        states?: Array<InventoryDocumentState> | null,
        internationalNameId?: string | null,
        code?: string | null,
        institutionIds?: Array<string> | null,
        legalEntityIds?: Array<string> | null,
        fromDate?: string | null,
        toDate?: string | null,
        searchTerm?: string | null,
    ): CancelablePromise<InvoicedDocumentListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/inventory/inquiries',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'states': states,
                'internationalNameId': internationalNameId,
                'code': code,
                'institutionIds': institutionIds,
                'legalEntityIds': legalEntityIds,
                'fromDate': fromDate,
                'toDate': toDate,
                'searchTerm': searchTerm,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates an inventory inquiry.
     * Creates an inventory inquiry with provided details.
     * @param requestBody
     * @returns any The entry has been created successfully.
     * @throws ApiError
     */
    public static createInquiryEndpoint(
        requestBody: CreateInquiryRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/inventory/inquiries',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Accept an inventory inquiry to the stock authority.
     * Accept an inventory inquiry to the stock authority
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static acceptInquiryEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/inventory/inquiries/{id}/accept',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The inquiry has not been found.`,
            },
        });
    }
    /**
     * Gets a list of inventory items.
     * Gets a list of inventory items.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param searchTerm Search by the products.
     * @param countries Search by the country.
     * @param producerIds Search by the producer id.
     * @param institutionIds Search by the institutions.
     * @param legalEntityIds
     * @param internationalNameIds Search by the active substances.
     * @param productGroupIds
     * @param productGroupCategories
     * @param statuses
     * @param dateTo
     * @param dateFrom
     * @param producedDateTo
     * @param producedDateFrom
     * @param expirationDateTo
     * @param expirationDateFrom
     * @param issuanceAllowance
     * @returns InventoryListResponse List of inventory items has been retrieved successfully.
     * @throws ApiError
     */
    public static getInventoryListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        searchTerm?: string | null,
        countries?: Array<Countries> | null,
        producerIds?: Array<string> | null,
        institutionIds?: Array<string> | null,
        legalEntityIds?: Array<string> | null,
        internationalNameIds?: Array<string> | null,
        productGroupIds?: Array<string> | null,
        productGroupCategories?: Array<ProductGroupCategory> | null,
        statuses?: Array<InventoryStatus> | null,
        dateTo?: string | null,
        dateFrom?: string | null,
        producedDateTo?: string | null,
        producedDateFrom?: string | null,
        expirationDateTo?: string | null,
        expirationDateFrom?: string | null,
        issuanceAllowance?: IssuanceAllowance | null,
    ): CancelablePromise<InventoryListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/inventory',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'countries': countries,
                'producerIds': producerIds,
                'institutionIds': institutionIds,
                'legalEntityIds': legalEntityIds,
                'internationalNameIds': internationalNameIds,
                'productGroupIds': productGroupIds,
                'productGroupCategories': productGroupCategories,
                'statuses': statuses,
                'dateTo': dateTo,
                'dateFrom': dateFrom,
                'producedDateTo': producedDateTo,
                'producedDateFrom': producedDateFrom,
                'expirationDateTo': expirationDateTo,
                'expirationDateFrom': expirationDateFrom,
                'issuanceAllowance': issuanceAllowance,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Exports a list of inventory items.
     * Exports a list of inventory items.
     * @param pageNumber
     * @param pageSize
     * @param searchTerm Search by the products.
     * @param countries Search by the country.
     * @param producerIds Search by the producer ids.
     * @param institutionIds Search by the institutions.
     * @param legalEntityIds Search by legal entity ids.
     * @param internationalNameIds Search by the active substances.
     * @param productGroupIds
     * @param statuses
     * @param dateTo
     * @param dateFrom
     * @param producedDateTo
     * @param producedDateFrom
     * @param expirationDateTo
     * @param expirationDateFrom
     * @param issuanceAllowance
     * @returns any List of inventory items has been exported successfully.
     * @throws ApiError
     */
    public static exportInventoryListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10000,
        searchTerm?: string | null,
        countries?: Array<Countries> | null,
        producerIds?: Array<string> | null,
        institutionIds?: Array<string> | null,
        legalEntityIds?: Array<string> | null,
        internationalNameIds?: Array<string> | null,
        productGroupIds?: Array<string> | null,
        statuses?: Array<InventoryStatus> | null,
        dateTo?: string | null,
        dateFrom?: string | null,
        producedDateTo?: string | null,
        producedDateFrom?: string | null,
        expirationDateTo?: string | null,
        expirationDateFrom?: string | null,
        issuanceAllowance?: IssuanceAllowance | null,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/inventory/export',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'countries': countries,
                'producerIds': producerIds,
                'institutionIds': institutionIds,
                'legalEntityIds': legalEntityIds,
                'internationalNameIds': internationalNameIds,
                'productGroupIds': productGroupIds,
                'statuses': statuses,
                'dateTo': dateTo,
                'dateFrom': dateFrom,
                'producedDateTo': producedDateTo,
                'producedDateFrom': producedDateFrom,
                'expirationDateTo': expirationDateTo,
                'expirationDateFrom': expirationDateFrom,
                'issuanceAllowance': issuanceAllowance,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Rejects an inventory entry.
     * Rejects an inventory entry by its id.
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static rejectEntryEndpoint(
        id: string,
        requestBody: RejectEntryRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/inventory/entries/{id}/reject',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The entry has not been found.`,
            },
        });
    }
    /**
     * Gets a list of inventory items.
     * Gets a list of inventory items.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param states
     * @param documentNumber
     * @param companyIds Search by the the company ids.
     * @param institutionIds Search by the institution ids.
     * @param legalEntityIds
     * @param fromDate Search by the invoice date.
     * @param toDate Search by the invoice date.
     * @param searchTerm
     * @returns InvoicedDocumentListResponse List of inventory items has been retrieved successfully.
     * @throws ApiError
     */
    public static getEntryListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        states?: Array<InventoryDocumentState> | null,
        documentNumber?: string | null,
        companyIds?: Array<string> | null,
        institutionIds?: Array<string> | null,
        legalEntityIds?: Array<string> | null,
        fromDate?: string | null,
        toDate?: string | null,
        searchTerm?: string | null,
    ): CancelablePromise<InvoicedDocumentListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/inventory/entries',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'states': states,
                'documentNumber': documentNumber,
                'companyIds': companyIds,
                'institutionIds': institutionIds,
                'legalEntityIds': legalEntityIds,
                'fromDate': fromDate,
                'toDate': toDate,
                'searchTerm': searchTerm,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates an inventory entry.
     * Creates an inventory entry with provided details.
     * @param requestBody
     * @returns any The entry has been created successfully.
     * @throws ApiError
     */
    public static createEntryEndpoint(
        requestBody: CreateEntryRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/inventory/entries',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets a product.
     * Gets a product with details.
     * @param id Medicine identifier.
     * @returns ExternalEntryDocumentResponse The product has been found.
     * @throws ApiError
     */
    public static getEntryEndpoint(
        id: string,
    ): CancelablePromise<ExternalEntryDocumentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/inventory/entries/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The product has not been found.`,
            },
        });
    }
    /**
     * Accepts an inventory entry.
     * Accepts an inventory entry by its id.
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static confirmEntryEndpoint(
        id: string,
        requestBody: ConfirmEntryRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/inventory/entries/{id}/confirm',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The entry has not been found.`,
            },
        });
    }
    /**
     * Gets a list of inventory returns.
     * Gets a list of inventory returns.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param states
     * @param code
     * @param roleIds
     * @param fromDate Search by the invoice date.
     * @param toDate Search by the invoice date.
     * @param searchTerm
     * @returns InternalInventoryDocumentListResponse List of inventory returns has been retrieved successfully.
     * @throws ApiError
     */
    public static getInternalReturnListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        states?: Array<InternalInventoryDocumentState> | null,
        code?: string | null,
        roleIds?: Array<string> | null,
        fromDate?: string | null,
        toDate?: string | null,
        searchTerm?: string | null,
    ): CancelablePromise<InternalInventoryDocumentListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/internal-inventory/returns',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'states': states,
                'code': code,
                'roleIds': roleIds,
                'fromDate': fromDate,
                'toDate': toDate,
                'searchTerm': searchTerm,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates an inventory return.
     * Creates an inventory return with provided details.
     * @param requestBody
     * @returns any The return has been created successfully.
     * @throws ApiError
     */
    public static createInternalReturnEndpoint(
        requestBody: CreateInternalReturnRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/internal-inventory/returns',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets a product.
     * Gets a product with details.
     * @param id Medicine identifier.
     * @returns InternalReturnDocumentResponse The product has been found.
     * @throws ApiError
     */
    public static getInternalReturnEndpoint(
        id: string,
    ): CancelablePromise<InternalReturnDocumentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/internal-inventory/returns/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The product has not been found.`,
            },
        });
    }
    /**
     * Rejects an inventory issuance.
     * Rejects an inventory issuance by its id.
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static rejectInternalIssuanceEndpoint(
        id: string,
        requestBody: RejectInternalIssuanceRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/internal-inventory/issuance/{id}/reject',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The entry has not been found.`,
            },
        });
    }
    /**
     * Gets a list of issuances.
     * Gets a list of issuances.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param states
     * @param code
     * @param roleIds Search by the institution ids.
     * @param fromDate Search by the invoice date.
     * @param toDate Search by the invoice date.
     * @param searchTerm
     * @returns InternalInventoryDocumentListResponse List of issuances has been retrieved successfully.
     * @throws ApiError
     */
    public static getInternalIssuanceListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        states?: Array<InternalInventoryDocumentState> | null,
        code?: string | null,
        roleIds?: Array<string> | null,
        fromDate?: string | null,
        toDate?: string | null,
        searchTerm?: string | null,
    ): CancelablePromise<InternalInventoryDocumentListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/internal-inventory/issuance',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'states': states,
                'code': code,
                'roleIds': roleIds,
                'fromDate': fromDate,
                'toDate': toDate,
                'searchTerm': searchTerm,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates an inventory issuance.
     * Creates an inventory issuance with provided details.
     * @param requestBody
     * @returns any The issuance has been created successfully.
     * @throws ApiError
     */
    public static createInternalIssuanceEndpoint(
        requestBody: CreateInternalIssuanceRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/internal-inventory/issuance',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets an issuance.
     * Gets an issuance details.
     * @param id Issuance identifier.
     * @returns InternalIssuanceDocumentResponse The issuance has been found.
     * @throws ApiError
     */
    public static getInternalIssuanceEndpoint(
        id: string,
    ): CancelablePromise<InternalIssuanceDocumentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/internal-inventory/issuance/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The product has not been found.`,
            },
        });
    }
    /**
     * Updates an inventory inquiry.
     * Updates an inventory inquiry with provided details.
     * @param id
     * @param requestBody
     * @returns any The entry has been created successfully.
     * @throws ApiError
     */
    public static updateInternalInquiryEndpoint(
        id: string,
        requestBody: UpdateInternalInquiryRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/stocks/internal-inventory/inquiries/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets a product.
     * Gets a product with details.
     * @param id Medicine identifier.
     * @returns InternalInquiryDocumentResponse The product has been found.
     * @throws ApiError
     */
    public static getInternalInquiryEndpoint(
        id: string,
    ): CancelablePromise<InternalInquiryDocumentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/internal-inventory/inquiries/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The product has not been found.`,
            },
        });
    }
    /**
     * Deletes an inventory inquiry to the stock authority.
     * Deletes an inventory inquiry to the stock authority
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteInternalInquiryEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/stocks/internal-inventory/inquiries/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The inquiry has not been found.`,
            },
        });
    }
    /**
     * Sends an inventory inquiry to the stock authority.
     * Sends an inventory inquiry to the stock authority
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static sendInternalInquiryEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/internal-inventory/inquiries/{id}/send',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The inquiry has not been found.`,
            },
        });
    }
    /**
     * Rejects an inventory inquiry.
     * Rejects an inventory inquiry by its id.
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static rejectInternalInquiryEndpoint(
        id: string,
        requestBody: RejectInternalInquiryRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/internal-inventory/inquiries/{id}/reject',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The entry has not been found.`,
            },
        });
    }
    /**
     * Gets a list of inventory inquiry items.
     * Gets a list of inquiry items.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param states Search by the state.
     * @param code
     * @param roleIds Search by the role ids.
     * @param fromDate Search by the invoice date.
     * @param toDate Search by the invoice date.
     * @param searchTerm
     * @returns InternalInventoryDocumentListResponse List of inventory items has been retrieved successfully.
     * @throws ApiError
     */
    public static getInternalInquiryListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        states?: Array<InternalInventoryDocumentState> | null,
        code?: string | null,
        roleIds?: Array<string> | null,
        fromDate?: string | null,
        toDate?: string | null,
        searchTerm?: string | null,
    ): CancelablePromise<InternalInventoryDocumentListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/internal-inventory/inquiries',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'states': states,
                'code': code,
                'roleIds': roleIds,
                'fromDate': fromDate,
                'toDate': toDate,
                'searchTerm': searchTerm,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates an inventory inquiry.
     * Creates an inventory inquiry with provided details.
     * @param requestBody
     * @returns any The entry has been created successfully.
     * @throws ApiError
     */
    public static createInternalInquiryEndpoint(
        requestBody: CreateInternalInquiryRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/internal-inventory/inquiries',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets a list of inventory items.
     * Gets a list of inventory items.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param searchTerm Search by the products.
     * @param countries Search by the country.
     * @param producerIds Search by the producer id.
     * @param roleIds
     * @param legalEntityIds Search by the legal entity.
     * @param internationalNameIds Search by the active substances.
     * @param internalInventoryItemIds
     * @param productGroupIds
     * @param dateTo
     * @param dateFrom
     * @param producedDateTo
     * @param producedDateFrom
     * @param expirationDateTo
     * @param expirationDateFrom
     * @returns InternalInventoryListResponse List of inventory items has been retrieved successfully.
     * @throws ApiError
     */
    public static getInternalInventoryListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        searchTerm?: string | null,
        countries?: Array<Countries> | null,
        producerIds?: Array<string> | null,
        roleIds?: Array<string> | null,
        legalEntityIds?: Array<string> | null,
        internationalNameIds?: Array<string> | null,
        internalInventoryItemIds?: Array<string> | null,
        productGroupIds?: Array<string> | null,
        dateTo?: string | null,
        dateFrom?: string | null,
        producedDateTo?: string | null,
        producedDateFrom?: string | null,
        expirationDateTo?: string | null,
        expirationDateFrom?: string | null,
    ): CancelablePromise<InternalInventoryListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/internal-inventory',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'countries': countries,
                'producerIds': producerIds,
                'roleIds': roleIds,
                'legalEntityIds': legalEntityIds,
                'internationalNameIds': internationalNameIds,
                'internalInventoryItemIds': internalInventoryItemIds,
                'productGroupIds': productGroupIds,
                'dateTo': dateTo,
                'dateFrom': dateFrom,
                'producedDateTo': producedDateTo,
                'producedDateFrom': producedDateFrom,
                'expirationDateTo': expirationDateTo,
                'expirationDateFrom': expirationDateFrom,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Exports a list of inventory items.
     * Exports a list of inventory items.
     * @param pageNumber
     * @param pageSize
     * @param searchTerm Search by the products.
     * @param countries Search by the country.
     * @param producerIds Search by the producer ids.
     * @param roleIds
     * @param legalEntityIds Search by legal entity ids.
     * @param internationalNameIds Search by the active substances.
     * @param internalInventoryItemIds
     * @param productGroupIds
     * @param dateTo
     * @param dateFrom
     * @param producedDateTo
     * @param producedDateFrom
     * @param expirationDateTo
     * @param expirationDateFrom
     * @returns any List of inventory items has been exported successfully.
     * @throws ApiError
     */
    public static exportInternalInventoryListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        searchTerm?: string | null,
        countries?: Array<Countries> | null,
        producerIds?: Array<string> | null,
        roleIds?: Array<string> | null,
        legalEntityIds?: Array<string> | null,
        internationalNameIds?: Array<string> | null,
        internalInventoryItemIds?: Array<string> | null,
        productGroupIds?: Array<string> | null,
        dateTo?: string | null,
        dateFrom?: string | null,
        producedDateTo?: string | null,
        producedDateFrom?: string | null,
        expirationDateTo?: string | null,
        expirationDateFrom?: string | null,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/internal-inventory/export',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'searchTerm': searchTerm,
                'countries': countries,
                'producerIds': producerIds,
                'roleIds': roleIds,
                'legalEntityIds': legalEntityIds,
                'internationalNameIds': internationalNameIds,
                'internalInventoryItemIds': internalInventoryItemIds,
                'productGroupIds': productGroupIds,
                'dateTo': dateTo,
                'dateFrom': dateFrom,
                'producedDateTo': producedDateTo,
                'producedDateFrom': producedDateFrom,
                'expirationDateTo': expirationDateTo,
                'expirationDateFrom': expirationDateFrom,
            },
            errors: {
                400: `Required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Rejects an inventory entry.
     * Rejects an inventory entry by its id.
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static rejectInternalEntryEndpoint(
        id: string,
        requestBody: RejectInternalEntryRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/internal-inventory/entries/{id}/reject',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The entry has not been found.`,
            },
        });
    }
    /**
     * Gets a list of inventory items.
     * Gets a list of inventory items.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param states
     * @param code
     * @param roleIds Search by the role ids.
     * @param fromDate Search by the invoice date.
     * @param toDate Search by the invoice date.
     * @param searchTerm
     * @returns InvoicedDocumentListResponse List of inventory items has been retrieved successfully.
     * @throws ApiError
     */
    public static getInternalEntryListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        states?: Array<InternalInventoryDocumentState> | null,
        code?: string | null,
        roleIds?: Array<string> | null,
        fromDate?: string | null,
        toDate?: string | null,
        searchTerm?: string | null,
    ): CancelablePromise<InvoicedDocumentListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/internal-inventory/entries',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'states': states,
                'code': code,
                'roleIds': roleIds,
                'fromDate': fromDate,
                'toDate': toDate,
                'searchTerm': searchTerm,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets a product.
     * Gets a product with details.
     * @param id Medicine identifier.
     * @returns InternalEntryDocumentResponse The product has been found.
     * @throws ApiError
     */
    public static getInternalEntryEndpoint(
        id: string,
    ): CancelablePromise<InternalEntryDocumentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/internal-inventory/entries/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The product has not been found.`,
            },
        });
    }
    /**
     * Accepts an inventory entry.
     * Accepts an inventory entry by its id.
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static confirmInternalEntryEndpoint(
        id: string,
        requestBody: ConfirmInternalEntryRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/internal-inventory/entries/{id}/confirm',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The entry has not been found.`,
            },
        });
    }
    /**
     * Gets a list of inventory consumptions.
     * Gets a list of inventory consumptions.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param states
     * @param code
     * @param roleIds
     * @param fromDate Search by the invoice date.
     * @param toDate Search by the invoice date.
     * @param searchTerm
     * @returns InternalInventoryListResponse List of inventory consumptions has been retrieved successfully.
     * @throws ApiError
     */
    public static getInternalConsumptionListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        states?: Array<InternalInventoryDocumentState> | null,
        code?: string | null,
        roleIds?: Array<string> | null,
        fromDate?: string | null,
        toDate?: string | null,
        searchTerm?: string | null,
    ): CancelablePromise<InternalInventoryListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/internal-inventory/consumptions',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'states': states,
                'code': code,
                'roleIds': roleIds,
                'fromDate': fromDate,
                'toDate': toDate,
                'searchTerm': searchTerm,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Creates an inventory consumption.
     * Creates an inventory consumption with provided details.
     * @param requestBody
     * @returns any The consumption has been created successfully.
     * @throws ApiError
     */
    public static createInternalConsumptionEndpoint(
        requestBody: CreateInternalConsumptionRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/stocks/internal-inventory/consumptions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets an internal consumption document.
     * Gets an internal consumption document.
     * @param id document identifier.
     * @returns InternalConsumptionDocumentResponse The document has been found.
     * @throws ApiError
     */
    public static getInternalConsumptionEndpoint(
        id: string,
    ): CancelablePromise<InternalConsumptionDocumentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/stocks/internal-inventory/consumptions/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The document has not been found.`,
            },
        });
    }
}
